import { useState } from 'react'
import { login, logout } from '../firebase'
import './AdminPanel.css'

export default function AdminPanel({ products, auth, onAuth, onClose, onAdd, onUpdate, onDelete, onReorder }) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [authError, setAuthError] = useState('')
  const [authLoading, setAuthLoading] = useState(false)
  const [view, setView] = useState('list')
  const [form, setForm] = useState({ name: '', image: '', price: '', inStock: true })
  const [editId, setEditId] = useState(null)
  const [deleteConfirm, setDeleteConfirm] = useState(null)

  const handleAuth = async (e) => {
    e.preventDefault()
    setAuthLoading(true)
    setAuthError('')
    try {
      await login(email, password)
      onAuth()
    } catch (err) {
      setAuthError('Email o contraseña incorrectos')
    } finally {
      setAuthLoading(false)
    }
  }

  const handleLogout = async () => {
    await logout()
    onClose()
  }

  const openAdd = () => {
    setForm({ name: '', image: '', price: '', inStock: true })
    setEditId(null)
    setView('form')
  }

  const openEdit = (product) => {
    setForm({
      name: product.name,
      image: product.image || '',
      price: product.price || '',
      inStock: product.inStock !== false,
    })
    setEditId(product.id)
    setView('form')
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!form.name.trim()) return
    if (editId) {
      onUpdate(editId, { name: form.name.trim(), image: form.image.trim(), price: form.price.trim(), inStock: form.inStock })
    } else {
      onAdd({ name: form.name.trim(), image: form.image.trim(), price: form.price.trim(), inStock: form.inStock })
    }
    setView('list')
  }

  const handleDelete = (id) => {
    if (deleteConfirm === id) {
      onDelete(id)
      setDeleteConfirm(null)
    } else {
      setDeleteConfirm(id)
    }
  }

  const abrirCloudinary = () => {
    window.cloudinary.openUploadWidget(
      {
        cloudName: 'dxyhjkooo',
        uploadPreset: 'lumi_crafts',
        sources: ['local', 'camera'],
        multiple: false,
        cropping: true,
        croppingAspectRatio: 1,
        language: 'es',
      },
      (error, result) => {
        if (!error && result.event === 'success') {
          setForm(f => ({ ...f, image: result.info.secure_url }))
        }
      }
    )
  }

  return (
    <div className="admin-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="admin-panel">
        <div className="admin-header">
          <h2>{view === 'form' ? (editId ? 'Editar producto' : 'Agregar producto') : 'Admin · Catálogo'}</h2>
          <div className="admin-header-actions">
            <button className="admin-close" onClick={auth ? handleLogout : onClose} aria-label="Cerrar">✕</button>
          </div>
        </div>

        {!auth ? (
          <form className="auth-form" onSubmit={handleAuth}>
            <p className="auth-label">Inicia sesión</p>
            <label>
              Correo
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
              />
            </label>
            <label>
              Contraseña
              <input
                type="password"
                placeholder="Contraseña"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
              />
            </label>
            {authError && <p className="auth-error">{authError}</p>}
            <button type="submit" className="btn-admin-primary" disabled={authLoading}>
              {authLoading ? 'Entrando...' : 'Entrar'}
            </button>
          </form>
        ) : view === 'list' ? (
          <div className="admin-list">
            <button className="btn-add" onClick={openAdd}>+ Agregar producto</button>
            {products.length === 0 && (
              <p className="empty-hint">No hay productos. Agrega el primero.</p>
            )}
            {products.map((p, i) => (
              <div key={p.id} className="admin-item">
                <div className="admin-item-img">
                  {p.image ? <img src={p.image} alt={p.name} /> : <span>🥃</span>}
                </div>
                <div className="admin-item-info">
                  <p className="admin-item-name">{p.name}</p>
                  {p.price && <p className="admin-item-price">${p.price} MXN</p>}
                </div>
                <div className="admin-item-actions">
                  <button className="btn-move" onClick={() => i > 0 && onReorder(i, i - 1)} disabled={i === 0}>↑</button>
                  <button className="btn-move" onClick={() => i < products.length - 1 && onReorder(i, i + 1)} disabled={i === products.length - 1}>↓</button>
                  <button className="btn-edit" onClick={() => openEdit(p)}>Editar</button>
                  <button className={`btn-delete ${deleteConfirm === p.id ? 'confirm' : ''}`} onClick={() => handleDelete(p.id)}>
                    {deleteConfirm === p.id ? '¿Seguro?' : 'Eliminar'}
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <form className="product-form" onSubmit={handleSubmit}>
            <label>
              Nombre del vaso *
              <input
                type="text"
                placeholder="Vaso Floral Rosa"
                value={form.name}
                onChange={e => setForm(f => ({ ...f, name: e.target.value }))}
                required
                autoFocus
              />
            </label>
            <label>
              Imagen
              <div className="img-upload-row">
                <input
                  type="url"
                  placeholder="https://... o sube una foto abajo"
                  value={form.image}
                  onChange={e => setForm(f => ({ ...f, image: e.target.value }))}
                />
                <button type="button" className="btn-cloudinary" onClick={abrirCloudinary}>
                  📁 Subir foto
                </button>
              </div>
            </label>
            {form.image && (
              <div className="img-preview">
                <img src={form.image} alt="preview" onError={e => e.target.style.display = 'none'} />
              </div>
            )}
            <label>
              Precio (opcional)
              <input
                type="number"
                placeholder="150"
                value={form.price}
                onChange={e => setForm(f => ({ ...f, price: e.target.value }))}
                min="0"
              />
            </label>
            <label>
              Con disponibilidad: 
              <input
                type="checkbox"
                checked={form.inStock}
                onChange={e => setForm(f => ({ ...f, inStock: e.target.checked }))}
              />
            </label>
            <div className="form-actions">
              <button type="button" className="btn-cancel" onClick={() => setView('list')}>Cancelar</button>
              <button type="submit" className="btn-admin-primary">
                {editId ? 'Guardar cambios' : 'Agregar'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  )
}
